import { SharedState } from 'app/types-shared';

export const getDashboardAdminAccess =
  (sharedState: SharedState): boolean =>
    sharedState?.access?.adminPanel?.dashboard?.administrationCentral || false;
